<template>
  <section class="price">
    <div class="container">
      <a-typography-title :level="1">
        AIPilot产品定价
      </a-typography-title>
      <a-row :gutter="[20,20]">
        <a-col v-for="(item,index) in expand.list"
               :xs="24" :md="12" :lg="8">
          <div class="item" :class="`i_${index+1}`">
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-row v-for="v in item.list"
                   justify="between">
              <a-col flex="auto">
                {{ v[0] }}
              </a-col>
              <a-col flex="auto">
                {{ v[1] }}
              </a-col>
            </a-row>
            <div class="money">
              <span v-if="item.price">
                <span v-if="item.isAbout"
                      class="left">
                  约
                </span>
                ¥{{ item.price }}
                <span v-if="item.isDiscount"
                      class="right">
                  优惠
                </span>
              </span>
              <template v-else>
                免费部署
              </template>
            </div>
          </div>
        </a-col>
      </a-row>
      <a-typography-paragraph>
        注：托管版费用以云服务器实际定价为准
      </a-typography-paragraph>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'product_price',
  data(): DataInterface {
    return {
      expand: {
        list: [
          {
            title: '单机部署版',
            list: [
              [ 'License', '永久升级' ],
              [ '用户数', 3 ],
              [ '应用', 10 ],
              [ '大模型对接', 9 ]
            ],
            price: 0,
            isAbout: false,
            isDiscount: true
          },
          {
            title: '集群部署版',
            list: [
              [ 'License', '永久升级' ],
              [ '用户数', 100 ],
              [ '应用', 50 ],
              [ '大模型对接', 9 ]
            ],
            price: 30000,
            isAbout: false,
            isDiscount: true
          },
          {
            title: '信创一体机',
            list: [
              [ 'CPU规格', '8核' ],
              [ '内存', '16GB' ],
              [ '硬盘', '500G' ],
              [ 'AIPilot软件单机版', '' ]
            ],
            price: 20000,
            isAbout: false,
            isDiscount: false
          },
          {
            title: '单机托管版',
            list: [
              [ 'CPU规格', '8核' ],
              [ '内存', '16GB' ],
              [ '硬盘', '500G' ],
              [ '网络', '5Mbps' ],
              [ '服务器有效期', '1年' ]
            ],
            price: 22000,
            isAbout: true,
            isDiscount: false
          },
          {
            title: '集群托管版',
            list: [
              [ 'CPU规格', '8核*3' ],
              [ '内存', '16GB*3' ],
              [ '硬盘', '500G*3' ],
              [ '网络', '5Mbps*3' ],
              [ '服务器有效期', '1年' ]
            ],
            price: 66000,
            isAbout: true,
            isDiscount: false
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@imagePublic: '@{src_image}page/public/';

.price {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  .bg('@{imagePublic}bg_1.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @font_7, @color_13, @font_7);
}

.ant-row {
  margin: @margin 0 0;
}

.item {
  @wh: 80px;
  @h: 50px;
  @style: fade(@color_white, 50), @color_white;
  position: relative;
  max-width: 300px;
  min-height: 215px+@h;
  padding: @padding @padding @h;
  margin: 0 auto;
  .gradientLinear(0deg, @style);
  border: 2px solid @color_14;
  border-radius: 8px;
  
  h5.ant-typography {
    margin: 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
    
    &:nth-child(2) {
      margin: @margin 0 0;
    }
    
    .ant-col {
      &:nth-child(1) {
        .font(left, @text, @color_13, @text);
      }
      
      &:nth-child(2) {
        .font(right, @text, @color_13, @text);
      }
    }
  }
  
  .money {
    display: flex;
    align-items: center;
    justify-content: center;
    height: @h;
    .position(bottom);
    .font(center, @text_big, @color_12, @text_big, true);
    
    > span {
      position: relative;
      
      span {
        line-height: @font_8;
        font-size: @font_8;
        
        &.left {
          .position(absolute, auto, auto, 2px, -20px);
        }
        
        &.right {
          .position(absolute, auto, -30px, 2px, auto);
        }
      }
    }
  }
}

@media screen and (min-width: @grid_xl) {
  .ant-row {
    .ant-col {
      flex: 1;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .price {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    min-height: auto;
    
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    .ant-row {
      .ant-col {
        &:nth-child(1) {
          .font(left, @font_7, @color_12, @font_7);
        }
        
        &:nth-child(2) {
          .font(right, @font_7, @color_12, @font_7);
        }
      }
    }
  }
}
</style>